import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import { getEnvDetail } from '../../../utils/env';
import notification from '@tt/components/Notification';
import Actions, { ActionTypes } from './actions';
import JobHistoryActions from '../../operations/job_history/actions';
import UnassignedJobOperation from '../../../services/operations/unassigned_jobs/actions';
import moment from 'moment';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';
const envDetail = getEnvDetail();

// Helper to handle label validation notifications for addorUpdateJob
function handleLabelValidationNotification(datajob, CONSTANT_VARIABLES, notification) {
  if (!datajob.isLabelValidation) return;
  if (datajob.labelValidationApiResponse == CONSTANT_VARIABLES.MODEL_NOT_TRAINED) {
    notification('info', CONSTANT_VARIABLES.JOB_PRODUCT_MODEL_IS_NOT_TRAINED);
  } else {
    notification('error', CONSTANT_VARIABLES.INTERNAL_SERVER_ERROR);
  }
}

function* isJobCompleted(jobId) {
  try {
    const { data } = yield call(api.put, {
      route: 'job/isJobCompleted/' + jobId,
    });
    return data;
  } catch (err) {
    console.warn(err);
    return false;
  }
}

function* isLineJobCompleted(id) {
  try {
    const { data } = yield call(api.put, {
      route: 'lineJob/isLineJobCompleted/' + id,
    });
    return data;
  } catch (err) {
    console.warn(err);
    return false;
  }
}
function* fetchJobGrid({ jobGridParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: jobGridParams.groupId
        ? `Job/Factory/` + jobGridParams.factoryId + '/' + jobGridParams.groupId
        : `Job/Factory/` + jobGridParams.factoryId,
    });
    const basicData = data.toJS();
    const jobGrid = { jobs: basicData.item1 === undefined ? basicData : basicData.item1, lineJobs: basicData.item2 };
    yield put(Actions.setJobGrid({ jobGrid }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* fetchUnassignedJobs({ jobGridParams }) {
  try {
    const { data } = yield call(api.get, {
      route: `Job/GetUnassignedJobs/` + jobGridParams.factoryId,
    });
    const unAssignedJobs = data ? data.toJS() : [];
    yield put(Actions.setUnassignedJobs({ unAssignedJobs }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* moveJob({ JobMoveParams, jobGridParams, jobType }) {
  try {
    if (
      JobMoveParams.SourceEquipmentId == null ||
      JobMoveParams.SourceJobId == null ||
      JobMoveParams.SourcePriority == null ||
      JobMoveParams.TargetPriority == null ||
      JobMoveParams.TargetEquipmentId == null
    ) {
      notification('error', 'Something went wrong!', '');
      yield put(Actions.setLoader({ showLoader: true }));
      yield put(Actions.fetchJobGrid({ jobGridParams }));
      return;
    }
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.put, {
      route: 'job/movejob',
      data: JobMoveParams,
    });
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.fetchJobGrid({ jobGridParams }));
    if (jobType === CONSTANT_VARIABLES.UNASSIGNED_JOB) {
      yield put(Actions.fetchUnassignedJobs({ jobGridParams }));
    }
    notification('success', CONSTANT_VARIABLES.JOB_MOVED, '');
  } catch (err) {
    const errorMessage =
      err.details?.response?.data?.toString() == CONSTANT_VARIABLES.JOB_ALREADY_UPDATED_ERROR
        ? CONSTANT_VARIABLES.JOB_ALREADY_UPDATED_ERROR
        : err.toString();

    notification('error', errorMessage, '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* moveLineJob({ LineJobMoveParams, jobGridParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.put, {
      route: 'linejob/movelinejob',
      data: LineJobMoveParams,
    });
    const jobData = data.toJS();
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.fetchJobGrid({ jobGridParams }));

    handleChangeMachineStateNotification({ jobData });
  } catch (err) {
    const errorMessage =
      err.details?.response?.data?.toString() == CONSTANT_VARIABLES.JOB_ALREADY_UPDATED_ERROR
        ? CONSTANT_VARIABLES.JOB_ALREADY_UPDATED_ERROR
        : err.toString();
    notification('error', errorMessage, '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}
function* moveUnassignedJobToLine({ JobMoveParams, jobGridParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.put, {
      route: 'linejob/moveUnassignedJobToLine',
      data: JobMoveParams,
    });
    const lineJob = data ? data.toJS() : [];
    yield put(Actions.setMoveUnassignedJob({ lineJob }));
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.fetchJobGrid({ jobGridParams }));
    yield put(Actions.fetchUnassignedJobs({ jobGridParams }));
    notification('success', CONSTANT_VARIABLES.JOB_MOVED, '');
  } catch (err) {
    const errorMessage =
      err.details?.response?.data?.toString() == CONSTANT_VARIABLES.JOB_ALREADY_UPDATED_ERROR
        ? CONSTANT_VARIABLES.JOB_ALREADY_UPDATED_ERROR
        : err.toString();
    notification('error', errorMessage, '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* changeMachineState({ jobStateParams, jobGridParams, notNeedPageUpdate, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.put, {
      route: 'job/updatestate/' + jobStateParams.jobId + (jobStateParams.jobRunningState ? '/Running' : '/Stopped'),
    });
    var jobData = data.toJS();

    yield put(Actions.setLoader({ showLoader: false }));
    if (!notNeedPageUpdate) {
      yield put(Actions.fetchJobGrid({ jobGridParams }));
    }
    handleChangeMachineStateNotification({ jobData });
    if (callback) callback();
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* setMachineState({ jobStateParams, jobGridParams }) {
  try {
    const jobCompleted = yield call(isJobCompleted, jobStateParams.jobId);
    if (!jobCompleted) {
      yield put(Actions.setLoader({ showLoader: true }));
      const { data } = yield call(api.put, {
        route: 'job/updatestate/' + jobStateParams.jobId + (jobStateParams.jobRunningState ? '/Running' : '/Stopped'),
      });
      var jobData = data.toJS();
      yield put(Actions.setLoader({ showLoader: false }));
      yield put(Actions.fetchJobGrid({ jobGridParams }));
      handleChangeMachineStateNotification({ jobData });
    } else {
      yield put(Actions.fetchJobGrid({ jobGridParams }));
      notification('error', CONSTANT_VARIABLES.JOB_ALREADY_COMPLETED, '');
    }
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* fetchErpWorkOrderNoExist({ erpWorkOrderNoParams, funcCallback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const encodedErpWorkOrder = encodeURIComponent(erpWorkOrderNoParams.erpWorkOrder);

    const { data } = yield call(api.get, {
      route: 'job/erpworkOrderNoExist/' + encodedErpWorkOrder + '/' + erpWorkOrderNoParams.id,
    });
    const erpWorkOrderNoData = data;
    if (funcCallback) funcCallback(data);
    yield put(Actions.setErpWorkOrderNoExist({ erpWorkOrderNoData }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* setLineMachineState({ lineJobStateParams, jobGridParams, callback }) {
  try {
    const lineJobCompleted = yield call(isLineJobCompleted, lineJobStateParams.lineJobId);
    if (!lineJobCompleted) {
      // Pre-check vision project deploy status before starting a job
      if (lineJobStateParams.lineJobRunningState) {
        const { data: isDeployed } = yield call(api.get, {
          route: 'lineJob/isVisionProjectDeployed/' + lineJobStateParams.lineJobId,
        });
        if (!isDeployed) {
          notification('error', CONSTANT_VARIABLES.VISION_PROJECT_NOT_DEPLOYED, '');
          return;
        }
      }

      yield put(Actions.setLoader({ showLoader: true }));
      const { data } = yield call(api.put, {
        route:
          'lineJob/updatestate/' +
          lineJobStateParams.lineJobId +
          (lineJobStateParams.lineJobRunningState ? '/Running' : '/Stopped'),
      });
      var jobData = data.toJS();

      yield put(Actions.setLoader({ showLoader: false }));
      if (jobGridParams) yield put(Actions.fetchJobGrid({ jobGridParams }));
      handleChangeMachineStateNotification({ jobData });
      if (callback && jobData.state == CONSTANT_VARIABLES.STOPPED) callback();
    } else {
      yield put(Actions.fetchJobGrid({ jobGridParams }));
      notification('error', CONSTANT_VARIABLES.JOB_ALREADY_COMPLETED, '');
    }
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* modalFetchProductTool({ productParams }) {
  try {
    yield put(Actions.setProductToolLoader({ productToolLoader: true }));
    const { data } = yield call(api.get, {
      route:
        '/product/getproductsearch/' +
        productParams.searchText +
        '/' +
        productParams.factoryId +
        '/' +
        productParams.lineId,
    });
    const productTool = data;
    yield put(Actions.modalSetProductTool({ productTool }));
    yield put(Actions.setProductToolLoader({ productToolLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setProductToolLoader({ productToolLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* handleJobGridUpdates(jobData, jobGridParams) {
  if (!jobData.priority && jobGridParams) {
    yield put(Actions.fetchUnassignedJobs({ jobGridParams }));
  }
  if (jobGridParams) {
    yield put(Actions.fetchJobGrid({ jobGridParams }));
  } else {
    yield put(UnassignedJobOperation.fetchUnassignedJobOperations());
  }
}

function* addorUpdateJob({ jobData, actionName, jobGridParams, callback }) {
  let files = new FormData();
  if (jobData.files) {
    for (const file of jobData.files) {
      files.append('files', file);
    }
  }
  delete jobData.files;

  if (jobData.jobProducts == null) {
    notification('error', 'Something went wrong.', '');
    return;
  }

  yield put(Actions.setLoader({ showLoader: true }));

  try {
    const isUpdate = actionName === CONSTANT_VARIABLES.UPDATE;
    const jobCompleted = isUpdate ? yield call(isJobCompleted, jobData.id) : false;

    if (jobCompleted) {
      yield put(Actions.setLoader({ showLoader: false }));
      notification('error', CONSTANT_VARIABLES.JOB_ALREADY_COMPLETED, '');
      return;
    }

    const { data } = yield call(isUpdate ? api.put : api.post, {
      route: 'job',
      data: jobData,
    });

    const datajob = data.toJS();
    yield call(api.post, {
      route: `job/UploadJobFiles/${datajob.id}/${0}`,
      data: files,
    });

    yield put(Actions.setLoader({ showLoader: false }));
    yield call(handleJobGridUpdates, jobData, jobGridParams);

    notification('success', isUpdate ? CONSTANT_VARIABLES.JOB_UPDATED : CONSTANT_VARIABLES.JOB_CREATED, '');

    if (callback) callback();

    handleLabelValidationNotification(datajob, CONSTANT_VARIABLES, notification);
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* fetchPackingTypes() {
  try {
    const { data } = yield call(api.get, {
      route: `lineJob/getPackingTypes`,
    });
    const allPackingTypes = data;
    yield put(Actions.setAllPackingTypes({ allPackingTypes }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addLineJob({ jobData, jobGridParams, callback }) {
  let files = new FormData();
  if (jobData.files) {
    for (const file of jobData.files) {
      files.append('files', file);
    }
  }

  delete jobData.files;
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.post, {
      route: 'lineJob/createLine',
      data: jobData,
    });
    const jobDataJs = data.toJS();
    yield call(api.post, {
      route: `lineJob/UploadJobFiles/${0}/${jobDataJs.id}`,
      data: files,
    });

    yield put(Actions.fetchJobGrid({ jobGridParams }));
    notification('success', CONSTANT_VARIABLES.LINE_JOB_CREATED, '');

    if (callback) callback();
    if (jobDataJs.isLabelValidation) {
      if (jobDataJs.labelValidationApiResponse == CONSTANT_VARIABLES.MODEL_NOT_TRAINED) {
        notification('info', CONSTANT_VARIABLES.JOB_PRODUCT_MODEL_IS_NOT_TRAINED);
      } else {
        notification('error', CONSTANT_VARIABLES.SERVER_ERROR);
      }
    }
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* UploadJobFiles(files, jobid) {
  try {
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* updateLineJob({ jobData, jobGridParams, callback }) {
  let files = new FormData();
  if (jobData.files) {
    for (const file of jobData.files) {
      files.append('files', file);
    }
  }
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    let lineJobCompleted = yield call(isLineJobCompleted, jobData.id);
    if (!lineJobCompleted) {
      const { data } = yield call(api.put, {
        route: 'lineJob',
        data: jobData,
      });
      const datajob = data.toJS();
      yield call(api.post, {
        route: `lineJob/UploadJobFiles/${0}/${datajob.id}`,
        data: files,
      });
      yield put(Actions.setLoader({ showLoader: false }));
      yield put(Actions.fetchJobGrid({ jobGridParams }));
      yield put(Actions.fetchLineJobByID({ lineJobId: { id: datajob.id } }));
      notification('success', CONSTANT_VARIABLES.LINE_JOB_UPDATED, '');
      if (callback) callback();
    } else {
      yield put(Actions.setLoader({ showLoader: false }));
      notification('error', CONSTANT_VARIABLES.JOB_ALREADY_COMPLETED, '');
    }
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* fetchJobTiming({ jobTimingParams }) {
  try {
    yield put(Actions.setJobTimingLoader({ jobTimingLoader: true }));
    const { data } = yield call(api.get, {
      route:
        'job/CalculateJobTimings/' +
        jobTimingParams.quantity +
        '/' +
        jobTimingParams.plannedCycleTime +
        '/' +
        jobTimingParams.cavity +
        '/' +
        jobTimingParams.equipmentId +
        '/' +
        jobTimingParams.productId +
        '/' +
        jobTimingParams.jobId +
        '/' +
        jobTimingParams.setupHours +
        '/' +
        jobTimingParams.toolId,
    });
    const jobTiming = data;
    const redata = data.toJS();
    if (redata.Message != null) {
      notification('info', redata.Message.toString(), '');
      yield put(Actions.setJobTiming({ jobTiming }));
      yield put(Actions.setJobTimingLoader({ jobTimingLoader: false }));
    } else {
      yield put(Actions.setJobTiming({ jobTiming }));
      yield put(Actions.setJobTimingLoader({ jobTimingLoader: false }));
    }
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setJobTimingLoader({ jobTimingLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* fetchLineJobTiming({ lineJobTimingParams }) {
  try {
    yield put(Actions.setJobTimingLoader({ jobTimingLoader: true }));
    const { data } = yield call(api.get, {
      route: 'linejob/calculateLineJobTimings',
      params: lineJobTimingParams,
    });

    const jobTiming = data;
    const redata = data.toJS();
    if (redata.Message != null) {
      notification('info', redata.Message.toString(), '');
      yield put(Actions.setJobTiming({ jobTiming }));
      yield put(Actions.setJobTimingLoader({ jobTimingLoader: false }));
    } else {
      yield put(Actions.setJobTiming({ jobTiming }));
      yield put(Actions.setJobTimingLoader({ jobTimingLoader: false }));
    }
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setJobTimingLoader({ jobTimingLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* fetchEquipmentJobs({ equipmentJobParams }) {
  try {
    const { data } = yield call(api.get, {
      route: 'job/job/' + equipmentJobParams.equipId + '/' + equipmentJobParams.shiftId + '/' + equipmentJobParams.date,
    });
    const equipmentJobsData = data;
    yield put(Actions.setEquipmentJobs({ equipmentJobsData }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}
function* fetchEquipmentJobsByEquipId({ equipmentId }) {
  try {
    const { data } = yield call(api.get, {
      route: 'job/job/' + equipmentId,
    });
    const equipmentJobsData = data;
    yield put(Actions.setEquipmentJobs({ equipmentJobsData }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}
function* fetchCompletedEquipmentJobsByEquipId({ equipmentId }) {
  try {
    const { data } = yield call(api.get, {
      route: 'job/job/completed/' + equipmentId,
    });
    const equipmentJobsData = data;
    yield put(Actions.setEquipmentJobs({ equipmentJobsData }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}
function* fetchJobActiveMaintenance({ activeMainenanceObj }) {
  try {
    yield put(Actions.setJobActiveMaintenanceLoader({ jobActiveMaintenanceLoader: true }));
    const { data } = yield call(api.get, {
      route: 'MaintenanceJob/IsActiveMaintenaceJob',
      params: activeMainenanceObj,
    });
    const jobActiveMaintenance = data;
    yield put(Actions.setJobActiveMaintenance({ jobActiveMaintenance }));
    yield put(Actions.setJobActiveMaintenanceLoader({ jobActiveMaintenanceLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setJobActiveMaintenanceLoader({ jobActiveMaintenanceLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* markCompleteJob({ JobCompleteParams, jobGridParams }) {
  try {
    const jobCompleted = yield call(isJobCompleted, JobCompleteParams.id);
    if (!jobCompleted) {
      yield call(api.put, {
        route: 'job/MarkJobCompleted',
        data: JobCompleteParams,
      });
      yield put(Actions.fetchJobGrid({ jobGridParams }));
      notification('success', CONSTANT_VARIABLES.JOB_MARK_COMPLETED, '');
    } else {
      yield put(Actions.fetchJobGrid({ jobGridParams }));
      notification('error', CONSTANT_VARIABLES.JOB_ALREADY_COMPLETED, '');
    }
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* markCompleteLineJob({ lineJobId, callback }) {
  try {
    const lineJobCompleted = yield call(isLineJobCompleted, lineJobId);
    if (!lineJobCompleted) {
      yield put(Actions.setLoader({ showLoader: true }));
      const { data } = yield call(api.put, {
        route: 'lineJob/MarkLineJobComplete/' + lineJobId,
      });
      const jobData = data ? data.toJS() : [];
      yield put(Actions.setLoader({ showLoader: false }));
      handleChangeMachineStateNotification({ jobData });
      if (callback) callback();
    } else {
      if (callback) callback();
      notification('error', CONSTANT_VARIABLES.JOB_ALREADY_COMPLETED, '');
    }
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* deleteJob({ jobId, jobGridParams }) {
  try {
    if (jobId.jobHistory) {
      yield put(JobHistoryActions.setJobHistoryOperationLoaderStatus({ jobHistoryOperationLoader: true }));
      yield call(api.delete, {
        route: 'Job/DeleteJobById/' + jobId.id,
      });
      yield put(
        JobHistoryActions.fetchJobHistoryOperation({ jobHistoryOperationParams: jobId.jobHistoryOperationParams })
      );
    } else {
      yield put(Actions.setLoader({ showLoader: true }));
      yield call(api.delete, {
        route: 'Job/DeleteJobById/' + jobId.id,
      });
      yield put(Actions.setLoader({ showLoader: false }));
      if (jobId.unassigned) {
        yield put(Actions.fetchUnassignedJobs({ jobGridParams }));
      }
      yield put(Actions.fetchJobGrid({ jobGridParams }));
    }
    notification('success', CONSTANT_VARIABLES.JOB_DELETED, '');
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(JobHistoryActions.setJobHistoryOperationLoaderStatus({ jobHistoryOperationLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* fetchJobByID({ jobId }) {
  try {
    yield put(Actions.setJobByIDLoader({ jobIdLoader: true }));
    const { data } = yield call(api.get, {
      route: 'job/' + jobId.id,
    });
    const updateJobData = data;
    yield put(Actions.setJobByID({ updateJobData }));
    yield put(Actions.setJobByIDLoader({ jobIdLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchLineConfigByLineAndProduct({ lineId, productId }) {
  try {
    yield put(Actions.setlineConfigLoader({ lineConfigLoader: true }));
    const { data } = yield call(api.get, {
      route: `lineJob/getLineConfigByLineAndProduct/${lineId}/${productId}`,
    });
    const lineConfigData = data ? data.toJS() : [];
    yield put(Actions.setLineConfigByLineId({ lineConfigData }));
    yield put(Actions.setlineConfigLoader({ lineConfigLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setlineConfigLoader({ lineConfigLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* fetchLineJobByID({ lineJobId, callback }) {
  try {
    yield put(Actions.setJobByIDLoader({ jobIdLoader: true }));
    const { data } = yield call(api.get, {
      route: 'lineJob/' + lineJobId.id,
    });
    const updateLineJobData = data;
    if (data == null || data == undefined || data == '') {
      yield put(Actions.setJobByIDLoader({ jobIdLoader: false }));
      notification('error', CONSTANT_VARIABLES.LINE_JOB_NOT_FOUND, '');
      if (callback) callback();
    } else {
      yield put(Actions.setLineJobByID({ updateLineJobData }));
      yield put(Actions.setJobByIDLoader({ jobIdLoader: false }));
    }
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchProductsByToolId({ toolData }) {
  try {
    yield put(Actions.setProductsByToolIdLoader({ productsByToolIdLoader: true }));
    const { data } = yield call(api.get, {
      route: 'product/getproductsbytool/' + toolData.id,
    });
    const productsData = data;
    yield put(Actions.setProductsByToolId({ productsData }));
    yield put(Actions.setProductsByToolIdLoader({ productsByToolIdLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setProductsByToolIdLoader({ productsByToolIdLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* addDowntime({ newDowntime }) {
  try {
    yield call(api.post, {
      route: 'downtime',
      data: newDowntime,
    });
    notification('success', CONSTANT_VARIABLES.DOWNTIME_CREATED, '');
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* indefiniteExist({ equipmentId }) {
  try {
    const { data } = yield call(api.get, {
      route: 'downtime/CheckIfIndefiniteDowntimeExists/' + equipmentId,
    });
    const exist = data;
    yield put(Actions.setIndefiniteExist({ exist }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* assignJobLabour({ operator, jobGridParams }) {
  try {
    yield call(api.post, {
      route: 'jobLabour/',
      data: operator,
    });
    yield put(Actions.setLoader({ showLoader: true }));
    yield put(Actions.fetchJobGrid({ jobGridParams }));
    notification('success', CONSTANT_VARIABLES.JOB_OPERATOR_CREATED, '');
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}
function* fetchExcelJobFile({ exportFileParams }) {
  try {
    yield put(Actions.setExportExcelJobFileLoader({ exportExcelFileLoader: true }));
    const { data } = yield call(api.get, {
      route: 'job/ExportJobs',
      params: exportFileParams,
    });
    const exportJobFile = data;
    yield put(Actions.setExcelJobFile({ exportJobFile }));
    yield put(Actions.setExportExcelJobFileLoader({ exportExcelFileLoader: false }));
    notification('success', CONSTANT_VARIABLES.JOB_EXPORT_SUCCESSFULLY, '');
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setExportExcelJobFileLoader({ exportExcelFileLoader: false }));
    console.warn(err); // Handle exception
  }
}
function* importExcelJobFile({ importFileParams }) {
  try {
    yield put(Actions.setImportExcelJobFileLoader({ importExcelFileLoader: true }));
    const { data } = yield call(api.post, {
      route: 'job/importjobs/' + importFileParams.factoryId,
      data: importFileParams.file,
    });
    const importJobFile = data;
    yield put(Actions.setImportExcelJobFile({ importJobFile }));
    yield put(Actions.setImportExcelJobFileLoader({ importExcelFileLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setImportExcelJobFileLoader({ importExcelFileLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* addUnplannedDowntime({ downtimeData, toolID, jobData, actionName, jobGridParams }) {
  try {
    const { data } = yield call(api.post, {
      route: 'Downtime/AddUnplannedDowntime',
      data: downtimeData,
    });
    jobData.cavity = jobData.cavity != undefined && jobData.cavity > 0 ? jobData.cavity : 1;
    if (
      jobData.quantity &&
      jobData.cavity &&
      jobData.plannedCheckObj.equipmentId &&
      jobData.plannedCycleTime &&
      jobData.setupHours &&
      toolID
    ) {
      if (jobData.lineId || jobData.lineID) {
        const lineJobTimingParams = {
          quantity: jobData.quantity,
          plannedCycleTime: jobData.plannedCycleTime,
          equipmentId: jobData.plannedCheckObj.equipmentId,
          productId:
            actionName === CONSTANT_VARIABLES.UPDATE
              ? jobData.line.lineProductEquipmentConfig[0].productId
              : jobData.jobProducts[0].productId,
          lineJobId: jobData.line ? jobData.line.id : null,
          setupHours: jobData.setupHours,
          toolID: toolID,
        };
        const { data } = yield call(api.get, {
          route: 'linejob/calculateLineJobTimings',
          params: lineJobTimingParams,
        });
        const jobTiming = data.toJS();
        jobData.fromTime = moment(jobTiming.fromTime);
        jobData.toTime = moment(jobTiming.estimatedCompletion);
        jobData.estimatedCompletion = moment(jobTiming.estimatedCompletion);
        delete jobData.isActiveMaintenaceJob;
        notification('success', CONSTANT_VARIABLES.DOWNTIME_CREATED, '');
        actionName === CONSTANT_VARIABLES.UPDATE
          ? yield put(Actions.updateLineJob({ jobData, jobGridParams }))
          : yield put(Actions.addLineJob({ jobData, jobGridParams }));
      } else {
        const { data } = yield call(api.get, {
          route:
            'job/CalculateJobTimings/' +
            jobData.quantity +
            '/' +
            jobData.plannedCycleTime +
            '/' +
            jobData.cavity +
            '/' +
            jobData.plannedCheckObj.equipmentId +
            '/' +
            jobData.jobProducts[0].productId +
            '/' +
            null +
            '/' +
            jobData.setupHours +
            '/' +
            toolID,
        });
        const jobTiming = data.toJS();
        jobData.fromTime = moment(jobTiming.fromTime);
        jobData.toTime = moment(jobTiming.estimatedCompletion);
        jobData.estimatedCompletion = moment(jobTiming.estimatedCompletion);
        delete jobData.isActiveMaintenaceJob;
        notification('success', CONSTANT_VARIABLES.DOWNTIME_CREATED, '');
        yield put(Actions.addorUpdateJob({ jobData, actionName, jobGridParams }));
      }
    }
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* editToolCavity({ toolCavity }) {
  try {
    yield put(Actions.setJobToolCavityLoader({ showJobToolCavityLoader: true }));
    yield call(api.put, {
      route: 'job/jobtoolcavity',
      data: toolCavity,
    });
    yield put(Actions.fetchToolCavityTable());
    notification('success', CONSTANT_VARIABLES.CAVITY_UPDATED, '');
    yield put(Actions.setJobToolCavityLoader({ showJobToolCavityLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setJobToolCavityLoader({ showJobToolCavityLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* fetchToolCavityTable() {
  try {
    yield put(Actions.setJobToolCavityLoader({ showJobToolCavityLoader: true }));
    const { data } = yield call(api.get, {
      route: `Job/JobToolCavities/`,
    });
    const toolCavityTable = data.toJS();
    yield put(Actions.setToolCavityTable({ toolCavityTable }));
    yield put(Actions.setJobToolCavityLoader({ showJobToolCavityLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setJobToolCavityLoader({ showJobToolCavityLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* fetchToolCavityByJobId(jobId) {
  try {
    yield put(Actions.setJobToolCavityLoader({ showJobToolCavityLoader: true }));
    const { data } = yield call(api.get, {
      route: `Job/ToolCavityByJobId/${jobId.jobId}`,
    });
    const toolCavityTable = data.toJS();
    yield put(Actions.setToolCavityTable({ toolCavityTable }));
    yield put(Actions.setJobToolCavityLoader({ showJobToolCavityLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setJobToolCavityLoader({ showJobToolCavityLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* fetchJobsByFactory({ factoryId }) {
  try {
    const { data } = yield call(api.get, {
      route: `job/factoryjobs/${factoryId}`,
    });
    const factoryJobs = data;
    yield put(Actions.setJobsByFactory({ factoryJobs }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchFilesForDownload({ rowId, fileName, jobGridParams }) {
  try {
    const { data } = yield call(api.get, {
      route: `job/GetUploadJobFileByFileId/${rowId}/${fileName}`,
    });
    const downloadJobDocFile = data;
    yield put(Actions.setFilesForDownload({ downloadJobDocFile }));
    if (jobGridParams) {
      yield put(Actions.fetchJobGrid({ jobGridParams }));
    }
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}
function* fetchJobImages({ jobId, imageType, jobImagesParams, dateFrom, dateTo, status }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    let route = `job/${jobId}/images/${imageType}/${jobImagesParams.pageNo}/${jobImagesParams.pageSize}`;
    const queryParams = [];
    if (dateFrom) {
      queryParams.push(`dateFrom=${encodeURIComponent(dateFrom)}`);
    }
    if (dateTo) {
      queryParams.push(`dateTo=${encodeURIComponent(dateTo)}`);
    }
    if (status) {
      queryParams.push(`status=${encodeURIComponent(status)}`);
    }
    if (queryParams.length > 0) {
      route += `?${queryParams.join('&')}`;
    }
    const { data } = yield call(api.get, {
      route,
    });
    const jobImages = data ? data.toJS() : [];
    yield put(Actions.setJobImages({ jobImages }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
    yield put(Actions.setLoader({ showLoader: false }));
  }
}
function* fetchJobImageTypes() {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `job/imageTypes`,
    });
    const jobImageTypes = data ? data.toJS() : [];
    yield put(Actions.setJobImageTypes({ jobImageTypes }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
    yield put(Actions.setLoader({ showLoader: false }));
  }
}

function* deleteJobDocFiles({ rowId, fileName, jobGridParams, isOperator }) {
  try {
    yield call(api.delete, {
      route: `job/DeleteFileByID/${rowId}/${fileName}`,
    });
    if (jobGridParams) {
      yield put(Actions.fetchJobGrid({ jobGridParams }));
    }
    if (isOperator) {
      yield put(UnassignedJobOperation.fetchUnassignedJobOperations());
    }
    notification('success', 'File Deleted Successfully!');
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* setLineJobPlcStatus({ lineJobPlcParams, jobGridParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.put, {
      route: 'LineJob/updateplcstatus/' + lineJobPlcParams.lineJobId + (lineJobPlcParams.plcStatus ? '/On' : '/Off'),
    });
    var LinejobData = data.toJS();
    yield put(Actions.fetchJobGrid({ jobGridParams }));

    notification('success', CONSTANT_VARIABLES.PLC_STATUS_CHANGED_SUCCESFULLY, '');

    if (LinejobData.isLabelValidation) {
      if (LinejobData.labelValidationApiResponse) {
        if (LinejobData.labelValidationApiResponse == CONSTANT_VARIABLES.INTERNAL_SERVER_ERROR) {
          notification('error', CONSTANT_VARIABLES.PLC_SERVER_ERROR);
        }
      }
    }
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* setJobPlcStatus({ jobPlcParams, jobGridParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.put, {
      route: 'job/updateplcstatus/' + jobPlcParams.jobId + (jobPlcParams.plcStatus ? '/On' : '/Off'),
    });
    var jobData = data.toJS();
    yield put(Actions.fetchJobGrid({ jobGridParams }));

    notification('success', CONSTANT_VARIABLES.PLC_STATUS_CHANGED_SUCCESFULLY, '');

    if (jobData.isLabelValidation) {
      if (jobData.labelValidationApiResponse) {
        if (jobData.labelValidationApiResponse == CONSTANT_VARIABLES.INTERNAL_SERVER_ERROR) {
          notification('error', CONSTANT_VARIABLES.PLC_SERVER_ERROR);
        }
      }
    }
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

const parser = labelsJson => {
  try {
    return JSON.parse(labelsJson);
  } catch (error) {
    return null;
  }
};
function* isJobRecordExist({ jobId }) {
  try {
    const { data } = yield call(api.get, {
      route: `Job/JobRecordsExist/` + jobId,
    });
    const isJobRecordExist = data;
    yield put(Actions.setIsJobRecordExist({ isJobRecordExist }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function handleChangeMachineStateNotification({ jobData }) {
  if (!jobData.isLabelValidation) {
    jobData.state === 'Completed'
      ? notification('success', CONSTANT_VARIABLES.JOB_MARK_COMPLETED, '')
      : jobData.state === 'Move'
      ? notification('success', CONSTANT_VARIABLES.JOB_MOVED, '')
      : notification('success', CONSTANT_VARIABLES.MACHINE_STATUS_CHANGED, '');
  }

  //error messages
  if (jobData.isLabelValidation) {
    let responses = parser(jobData.labelValidationApiResponse);
    let allResponsesAreSuccess = responses.every(x => x === null);

    if (allResponsesAreSuccess && jobData.state != 'Completed') {
      notification('success', CONSTANT_VARIABLES.MACHINE_STATUS_CHANGED, '');
    }

    if (allResponsesAreSuccess && jobData.state == 'Completed') {
      notification('success', CONSTANT_VARIABLES.JOB_MARK_COMPLETED, '');
    }
    if (!allResponsesAreSuccess && jobData.state == 'Stopped') {
      notification('success', CONSTANT_VARIABLES.MACHINE_STATUS_CHANGED, '');
    }
    if (!allResponsesAreSuccess && jobData.state == 'Completed') {
      notification('success', CONSTANT_VARIABLES.JOB_MARK_COMPLETED, '');
    }
    if (
      (jobData.labelValidationApiResponse == null || jobData.labelValidationApiResponse == 'Success') &&
      jobData.state == 'Move'
    ) {
      notification('success', CONSTANT_VARIABLES.JOB_MOVED, '');
    }
    if (jobData.labelValidationApiResponse) {
      const hasErrors = responses?.some(e => e?.ErrorInfo);
      if (hasErrors) {
        // Check if all errors are JSON_DESERIALIZATION_ERROR
        const jsonDeserializationErrors = responses.filter(
          e => e?.ErrorType === CONSTANT_VARIABLES.ERROR_TYPE_JSON_DESERIALIZATION_ERROR
        );
        if (
          jsonDeserializationErrors.length > 0 &&
          jsonDeserializationErrors.length === responses.filter(e => e?.ErrorInfo).length
        ) {
          // All errors are JSON_DESERIALIZATION_ERROR, show only one notification
          notification(
            'error',
            CONSTANT_VARIABLES.SERVER_ERROR,
            null,
            CONSTANT_VARIABLES.VISION_ERROR_NOTIFICATION_DURATION
          );
        } else {
          // Show notifications for other error types as before
          responses.forEach(e => {
            if (e?.ErrorInfo) {
              if (e.ErrorType === CONSTANT_VARIABLES.ERROR_TYPE_CAMERA_STOPPED) {
                notification(
                  'error',
                  CONSTANT_VARIABLES.CAMERA_NOT_RESPONDING.replace('{EquipmentName}', e.EquipmentName),
                  null,
                  CONSTANT_VARIABLES.VISION_ERROR_NOTIFICATION_DURATION
                );
              } else if (e.ErrorType === CONSTANT_VARIABLES.ERROR_TYPE_JOB_STATE_CONFLICT) {
                notification(
                  'error',
                  e.ErrorInfo.replace(/^Camera\s+\S+/, e.EquipmentName),
                  null,
                  CONSTANT_VARIABLES.VISION_ERROR_NOTIFICATION_DURATION
                );
              } else if (e.ErrorType === CONSTANT_VARIABLES.ERROR_TYPE_EMPTY_ATTRIBUTES) {
                notification(
                  'error',
                  CONSTANT_VARIABLES.EQUIPMENT_EMPTY_ATTRIBUTES.replace('{EquipmentName}', e.EquipmentName),
                  null,
                  CONSTANT_VARIABLES.VISION_ERROR_NOTIFICATION_DURATION
                );
              } else if (e.ErrorType === CONSTANT_VARIABLES.ERROR_TYPE_JSON_DESERIALIZATION_ERROR) {
                // Already handled above, skip here
              }
            }
          });
        }
      }
    } else if (
      jobData.labelValidationApiResponse == CONSTANT_VARIABLES.MODEL_NOT_TRAINED ||
      jobData.labelValidationApiResponse == CONSTANT_VARIABLES.DEVICE_NAME_WRONG
    ) {
      notification('info', CONSTANT_VARIABLES.JOB_PRODUCT_MODEL_IS_NOT_TRAINED);
    } else if (!allResponsesAreSuccess && jobData.state == 'Running') {
      notification('error', CONSTANT_VARIABLES.SERVER_ERROR);
    } else if (!allResponsesAreSuccess && jobData.state == 'Stopped') {
      notification('error', CONSTANT_VARIABLES.SERVER_ERROR_STOPPED);
    } else if (
      jobData.labelValidationApiResponse == CONSTANT_VARIABLES.INTERNAL_SERVER_ERROR &&
      (jobData.state == 'Completed' || jobData.state == 'Move')
    ) {
      notification('error', CONSTANT_VARIABLES.SERVER_ERROR_STOPPED);
    } else if (jobData.labelValidationApiResponse == CONSTANT_VARIABLES.INVALID_TOKEN_FORMAT) {
      notification('error', CONSTANT_VARIABLES.THINGTRAX_API_ERROR);
    }
  }
}

function* fetchJobIds({ id, isLine }) {
  try {
    if (id) {
      const { data } = yield call(api.get, {
        route: isLine ? `linejob/lineJobIds/${id}` : `job/jobIds/${id}`,
      });
      const jobIdsData = data;
      yield put(Actions.setJobIds({ jobIdsData }));
    }
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchJobByEquipId({ equipId }) {
  try {
    const { data } = yield call(api.get, {
      route: 'job/GetJobsByEquipmentId/' + equipId,
    });
    const jobByEquipId = data;
    yield put(Actions.setJobByEquipId({ jobByEquipId }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err);
  }
}

function* fetchJobByLineId({ lineId }) {
  try {
    const { data } = yield call(api.get, {
      route: 'job/GetJobsByLineId/' + lineId,
    });
    const jobByLineId = data;
    yield put(Actions.setJobByLineId({ jobByLineId }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err);
  }
}

function* fetchJobCameraProductAttributesByLineAndProduct({ lineId, productId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `lineJob/getJobCameraAttributesByLineAndProduct/${lineId}/${productId}`,
    });
    const jobCameraAttributesData = data ? data.toJS() : [];
    yield put(Actions.setJobCameraProductAttributesByLineAndProduct({ jobCameraAttributesData }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* validateVisionCompatibility({ targetLineId, jobId, callback }) {
  try {
    const { data } = yield call(api.get, {
      route: `lineJob/validateJobMove/${targetLineId}/${jobId}`,
    });
    const isJobMoveValid = data;
    if (callback) callback(isJobMoveValid);
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.DELETE_JOB_DOC_FILES, deleteJobDocFiles),
    takeLatest(ActionTypes.FETCH_FILES_FOR_DOWNLOAD, fetchFilesForDownload),
    takeLatest(ActionTypes.FETCH_JOB_GRID, fetchJobGrid),
    takeLatest(ActionTypes.FETCH_UNASSIGNED_JOBS, fetchUnassignedJobs),
    takeLatest(ActionTypes.FETCH_TOOL_CAVITY_TABLE, fetchToolCavityTable),
    takeLatest(ActionTypes.FETCH_TOOL_CAVITY_JOBID, fetchToolCavityByJobId),
    takeLatest(ActionTypes.MOVE_JOB, moveJob),
    takeLatest(ActionTypes.MOVE_LINE_JOB, moveLineJob),
    takeLatest(ActionTypes.MOVE_UNASSIGNED_JOB_TO_LINE, moveUnassignedJobToLine),
    takeLatest(ActionTypes.SET_MACHINE_STATE, setMachineState),
    takeLatest(ActionTypes.CHANGE_MACHINE_STATE, changeMachineState),
    takeLatest(ActionTypes.FETCH_ERP_WORK_ORDER_NO_EXIST, fetchErpWorkOrderNoExist),
    takeLatest(ActionTypes.FETCH_PACKINGTYPES, fetchPackingTypes),
    takeLatest(ActionTypes.SET_LINE_MACHINE_STATE, setLineMachineState),
    takeLatest(ActionTypes.MODAL_FETCH_PRODUCT_TOOL, modalFetchProductTool),
    takeLatest(ActionTypes.ADD_OR_UPDATE_JOB, addorUpdateJob),
    takeLatest(ActionTypes.UPLOAD_JOB_FILES, UploadJobFiles),
    takeLatest(ActionTypes.ADD_LINE_JOB, addLineJob),
    takeLatest(ActionTypes.UPDATE_LINE_JOB, updateLineJob),
    takeLatest(ActionTypes.EDIT_TOOL_CAVITY, editToolCavity),
    takeLatest(ActionTypes.FETCH_JOB_TIMING, fetchJobTiming),
    takeLatest(ActionTypes.FETCH_LINE_JOB_TIMING, fetchLineJobTiming),
    takeLatest(ActionTypes.FETCH_EQUIPMENT_JOBS, fetchEquipmentJobs),
    takeLatest(ActionTypes.FETCH_EQUIPMENT_JOBS_BY_EQUIPID, fetchEquipmentJobsByEquipId),
    takeLatest(ActionTypes.FETCH_COMPLETED_EQUIPMENT_JOBS_BY_EQUIPID, fetchCompletedEquipmentJobsByEquipId),
    takeLatest(ActionTypes.FETCH_JOB_ACTIVE_MAINTENANCE, fetchJobActiveMaintenance),
    takeLatest(ActionTypes.MARK_COMPLETE_JOB, markCompleteJob),
    takeLatest(ActionTypes.MARK_COMPLETE_LINE_JOB, markCompleteLineJob),
    takeLatest(ActionTypes.DELETE_JOB, deleteJob),
    takeLatest(ActionTypes.FETCH_JOB_DATA_BY_JOB_ID, fetchJobByID),
    takeLatest(ActionTypes.FETCH_LINE_CONFIG_DATA_BY_LINE_AND_PRODUCT, fetchLineConfigByLineAndProduct),
    takeLatest(ActionTypes.FETCH_LINE_JOB_DATA_BY_LINE_JOB_ID, fetchLineJobByID),
    takeLatest(ActionTypes.FETCH_PRODUCT_DATA_BY_TOOL_ID, fetchProductsByToolId),
    takeLatest(ActionTypes.ADD_DOWNTIME, addDowntime),
    takeLatest(ActionTypes.INDEFINITE_EXIST, indefiniteExist),
    takeLatest(ActionTypes.ADD_UNPLANNED_DOWNTIME, addUnplannedDowntime),
    takeLatest(ActionTypes.ASSIGN_JOB_LABOUR, assignJobLabour),
    takeLatest(ActionTypes.FETCH_EXCEL_JOB_FILE, fetchExcelJobFile),
    takeLatest(ActionTypes.IMPORT_EXCEL_JOB_FILE, importExcelJobFile),
    takeLatest(ActionTypes.FETCH_JOBS_BY_FACTORY, fetchJobsByFactory),
    takeLatest(ActionTypes.SET_LINE_JOB_PLC_STATUS, setLineJobPlcStatus),
    takeLatest(ActionTypes.SET_JOB_PLC_STATUS, setJobPlcStatus),
    takeLatest(ActionTypes.FETCH_JOB_IMAGES, fetchJobImages),
    takeLatest(ActionTypes.FETCH_JOB_IMAGE_TYPES, fetchJobImageTypes),
    takeLatest(ActionTypes.FETCH_JOB_IDS, fetchJobIds),
    takeLatest(ActionTypes.IS_JOB_RECORD_EXIST, isJobRecordExist),
    takeLatest(ActionTypes.FETCH_JOB_BY_EQUIP_ID, fetchJobByEquipId),
    takeLatest(ActionTypes.FETCH_JOB_BY_LINE_ID, fetchJobByLineId),
    takeLatest(
      ActionTypes.FETCH_JOB_CAMERA_PRODUCT_ATTRIBUTES_BY_LINE_AND_PRODUCT,
      fetchJobCameraProductAttributesByLineAndProduct
    ),
    takeLatest(ActionTypes.VALIDATE_VISION_COMPATIBILITY, validateVisionCompatibility),
  ]);
}
